import { Controller } from '@hotwired/stimulus';

/** Handles postMessage events from Google OAuth popup callbacks. */
export default class extends Controller {
  static values = {
    successAction: { type: String, default: 'redirect' },
  };

  connect() {
    this._onOAuthPopupMessage = this.onOAuthPopupMessage.bind(this);
    window.addEventListener('message', this._onOAuthPopupMessage);
  }

  disconnect() {
    window.removeEventListener('message', this._onOAuthPopupMessage);
  }

  onOAuthPopupMessage(event) {
    if (event.origin !== window.location.origin) return;

    const data = event.data;
    if (!data || data.type !== 'better-sheets-oauth') return;

    if (data.status === 'success') {
      if (this.successActionValue === 'reload') {
        window.location.reload();
      } else {
        const returnTo = data.returnTo;
        if (returnTo) {
          // Stripe checkout URLs are off-origin; assign (not Turbo) so we leave the site for payment.
          if (/^https?:\/\//i.test(returnTo)) {
            window.location.href = returnTo;
          } else {
            window.location.assign(returnTo);
          }
        } else {
          window.location.reload();
        }
      }
      return;
    }

    const msg = data.message || "Google sign-in didn't finish. You can try again.";
    window.alert(msg);
  }
}
